import { translations } from "./translations";

export {
  translations,
}



// WEBPACK FOOTER //
// ./locales/ru_UA/index.js